module.exports = __webpack_public_path__ + "img/brandLogo.920da1fa.png";